export default {
  title: "Log in",
  register: "Register",
  forgotPassword: "Forgot Password",
  submit: "Submit",
  helper: "Don't have access to your personal account?",
  helperText:
    "Access to the personal account is provided by an exhibition manager only after the conclusion of the contract. You will receive an e-mail that will enable you to activate all the features of your personal account.",
  error: {
    email: "Enter your e-mail",
    userNotFound: "Wrong login or password",
    emailNotConfirmed: "Your e-mail isn't confirmed"
  }
};
